module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Administração'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administrador"
    }
  }, [_c('a', [_vm._v("Ativar ou desativar permissão de administrador")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/projetos-aguardando-aprovacao"
    }
  }, [_c('a', [_vm._v("Aprovar, devolver para o coordenador ou inabilitar ações de extensão aguardando aprovação")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/projetos-concluir"
    }
  }, [_c('a', [_vm._v("Concluir ou desfazer a finalização de ações de extensão aguardando relatório")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/relatorios-aguardando-aprovacao"
    }
  }, [_c('a', [_vm._v("Aprovar, devolver para o coordenador ou reprovar relatórios técnicos aguardando aprovação")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/projetos-vencidos"
    }
  }, [_c('a', [_vm._v("Ações com mais de 6 meses em preenchimento incompleto")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/projetos-parceiros"
    }
  }, [_c('a', [_vm._v("Lista de projetos que possuem parceiros")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/relatorios-de-gestao"
    }
  }, [_c('a', [_vm._v("Gerar relatórios de gestão")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/nova-mensagem"
    }
  }, [_c('a', [_vm._v("Alterar mensagem inicial")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/usuarios-proex"
    }
  }, [_c('a', [_vm._v("Lista de Usuários-Proex")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/relatorio-seguro"
    }
  }, [_c('a', [_vm._v("Relatório de seguro")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/reprovar-relatorios-suspensao-coordenador"
    }
  }, [_c('a', [_vm._v("Reprovação de Relatório com Suspensão de Coordenador")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/registro-envio-relatorio"
    }
  }, [_c('a', [_vm._v("Registro de Envio de Relatórios de Projeto")])])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c549296","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/administracao/administracao.vue
// module id = 655
// module chunks = 0